module.exports = __webpack_public_path__ + "img/scc-log.f3db92cd.png";